export const MAX_32_SAFE_NUMBER = 2147483647;
